import { isBulkCertasOil, isCertasOil } from 'components/StockInfo/catalogStockUtils';
import { ReferenceLocal } from 'domains/basket/Basket.types';

export type StockValidationDecision = 'WAIT' | 'OPEN_CONFIRMATION' | 'CHECKOUT';

export const isCertasReferenceForStockValidation = (
  reference: ReferenceLocal,
  isBulkOilUser: boolean,
  isOilUserR1: boolean,
): boolean =>
  (isBulkOilUser && isBulkCertasOil(reference.familyCode, reference.productModelCode, reference.packaging)) ||
  (isOilUserR1 && isCertasOil(reference.familyCode, reference.productModelCode));

interface StockValidationDecisionInput {
  pendingStockCheckId?: string;
  processedStockCheckId?: string;
  hasSufficientQuantityAvailable: boolean;
  isStockCheckResolved: boolean;
  hasChangedWarehouses: boolean;
}

export const getStockValidationDecision = ({
  pendingStockCheckId,
  processedStockCheckId,
  hasSufficientQuantityAvailable,
  isStockCheckResolved,
  hasChangedWarehouses,
}: StockValidationDecisionInput): StockValidationDecision => {
  if (!pendingStockCheckId || processedStockCheckId === pendingStockCheckId) {
    return 'WAIT';
  }
  if (!hasSufficientQuantityAvailable) {
    return 'OPEN_CONFIRMATION';
  }
  if (!isStockCheckResolved) {
    return 'WAIT';
  }
  if (hasChangedWarehouses) {
    return 'OPEN_CONFIRMATION';
  }

  return 'CHECKOUT';
};
